import { TextFacetLocal } from 'components/Filter/Filter.types';
import { RENATIVE_FAMILY_CODE } from 'domains/catalog/Catalog.types';

export const getExtendedFacetMaps = (
  defaultMap: Map<string, { label: string; ids: string[] }>,
  textFacets?: TextFacetLocal[],
): Map<string, { label: string; ids: string[] }> => {
  textFacets?.forEach((facet) => {
    if (!defaultMap.has(facet.id)) {
      defaultMap.set(facet.id, {
        label: facet.id,
        ids: [],
      });
    }
  });

  return defaultMap;
};

export function checkRenative(familyCode: string | undefined, renative = false): boolean {
  return renative || familyCode === RENATIVE_FAMILY_CODE;
}
